import PropTypes from "prop-types"
import { ButtonBase, ListItemIcon, Typography } from "@mui/material"

// ButtonBase, not MenuItem: this is rendered inside a Popover, not a Menu/MenuList
// (Popover is the positioning primitive Menu is built on, but doesn't itself
// provide MenuListContext) — MUI v9's MenuItem now requires that context.
export default function HelpItem({ url, title, icon, onClick }) {
  return <ButtonBase className="menu-help-item" component="a" href={url} target="_blank" rel="noreferrer" onClick={onClick}>
    <Typography variant="inherit">{title}</Typography>
    {icon && <ListItemIcon>
      {icon}
    </ListItemIcon>}
  </ButtonBase>
}

HelpItem.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  onClick: PropTypes.func.isRequired,
}
